var map = {
	"./deposit#00E7FF.png": 4481,
	"./deposit#06D0C2.png": 4829,
	"./deposit#268368.png": 7375,
	"./deposit#288268.png": 325,
	"./deposit#34d5f5.png": 7995,
	"./deposit#DB9928.png": 2974,
	"./deposit#F49D1A.png": 3483,
	"./deposit#FEB139.png": 6551,
	"./deposit#FFB902.png": 3297,
	"./deposit#FFCE00.png": 373,
	"./deposit#e4a22a.png": 3291,
	"./deposit#ff8f00.png": 675
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3750;